var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action, observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { runtime } from '../../../../classes/runtime/Runtime';
import { xa } from '../../../../utils/xa/xa';
let MenubarPremiseInteraction = class MenubarPremiseInteraction extends React.PureComponent {
    isPlayIconHovering = false;
    isPlayIconClicked = false;
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    render() {
        const { app } = this.props;
        if (this.isPlayIconClicked)
            return null;
        // vgwort
        if (runtime.browserRuntime.browserAddressBar.locationSnapshot.hash.includes('content')) {
            xa.topic.setVgMode({});
            return null;
        }
        return (React.createElement("div", { style: {
                position: 'fixed',
                top: '50%',
                left: '50%',
                color: '#fff',
                cursor: 'pointer',
                marginTop: 0 - app.stage.stageInnerMeasure.stageHeightInPixel / 4,
                marginLeft: 0 - app.stage.stageInnerMeasure.stageHeightInPixel / 4,
            }, onMouseEnter: action(() => (this.isPlayIconHovering = true)), onMouseLeave: action(() => (this.isPlayIconHovering = false)), onClick: action(() => {
                if (app.appPremise.isWaitingForFullScreen) {
                    runtime.solidBrowserRuntime.browserFullscreen.requestFullScreen();
                }
                this.isPlayIconClicked = true;
                //
            }) },
            React.createElement("i", { className: "fas fa-play", title: "Klicke auf Play, um das Thema zu starten", style: {
                    fontSize: app.stage.stageInnerMeasure.stageHeightInPixel / 2,
                    opacity: this.isPlayIconHovering ? 0.6 : 0.4,
                    transition: 'opacity 500ms ease-out',
                } })));
    }
};
__decorate([
    observable
], MenubarPremiseInteraction.prototype, "isPlayIconHovering", void 0);
__decorate([
    observable
], MenubarPremiseInteraction.prototype, "isPlayIconClicked", void 0);
MenubarPremiseInteraction = __decorate([
    observer
], MenubarPremiseInteraction);
export { MenubarPremiseInteraction };
